export class JamOnboardingVideoDetails {
  url: string | null = null;
  title: string | null = null;
  description: string | null = null;

  static fromPlainObject(obj: any): JamOnboardingVideoDetails {
    return Object.assign(new JamOnboardingVideoDetails(), obj || {}) as JamOnboardingVideoDetails;
  }
}
